export default __webpack_public_path__ + "static/media/customer.53995a25.png";